import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Problems from './components/Problems';
import Chapters from './components/Chapters';
import AudienceFit from './components/AudienceFit';
import KeyFacts from './components/KeyFacts';
import Faq from './components/Faq';
import FinalCta from './components/FinalCta';
import Footer from './components/Footer';
import './App.css';

function App() {
  return (
    <div className="min-h-screen bg-[#F9FAFB] font-sans text-[#111827]">
      <Header />
      <main>
        <Hero />
        <Problems />
        <Chapters />
        <AudienceFit />
        <KeyFacts />
        <Faq />
        <FinalCta />
      </main>
      <Footer />
    </div>
  );
}

export default App;